/**
 * Cookie plugin
 *
 * Copyright (c) 2006 Klaus Hartl (stilbuero.de)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

 jQuery.cookie=function(b,j,m){if(typeof j!="undefined"){m=m||{};if(j===null){j="";m.expires=-1}var e="";if(m.expires&&(typeof m.expires=="number"||m.expires.toUTCString)){var f;if(typeof m.expires=="number"){f=new Date();f.setTime(f.getTime()+(m.expires*24*60*60*1000))}else{f=m.expires}e="; expires="+f.toUTCString()}var l=m.path?"; path="+(m.path):"";var g=m.domain?"; domain="+(m.domain):"";var a=m.secure?"; secure":"";document.cookie=[b,"=",encodeURIComponent(j),e,l,g,a].join("")}else{var d=null;if(document.cookie&&document.cookie!=""){var k=document.cookie.split(";");for(var h=0;h<k.length;h++){var c=jQuery.trim(k[h]);if(c.substring(0,b.length+1)==(b+"=")){d=decodeURIComponent(c.substring(b.length+1));break}}}return d}};

 /**
  * Module to show Recently Viewed Products
  *
  * Copyright (c) 2014 Caroline Schnapp (11heavens.com)
  * Dual licensed under the MIT and GPL licenses:
  * http://www.opensource.org/licenses/mit-license.php
  * http://www.gnu.org/licenses/gpl.html
  *
  */
 
 Shopify.Products = (function() {
     var config = {
         howManyToShow: 3,
         howManyToStoreInMemory: 10,
         wrapperId: 'recently-viewed-products',
         templateId: 'recently-viewed-product-template',
         layout: 'slider',
         swipe: true,
         media: 'adapt',
         onComplete: null
     };
     var productHandleQueue = [];
     var wrapper = null;
     var template = null;
     var shown = 0;
     var cookie = {
         configuration: {
             expires: 90,
             path: '/',
             domain: window.location.hostname
         },
         name: 'shopify_recently_viewed',
         write: function(recentlyViewed) {
             jQuery.cookie(this.name, recentlyViewed.join(' '), this.configuration);
         },
         read: function() {
             var recentlyViewed = [];
             var cookieValue = jQuery.cookie(this.name);
             if (cookieValue !== null) {
                 recentlyViewed = cookieValue.split(' ');
             }
             return recentlyViewed;
         },
         destroy: function() {
             jQuery.cookie(this.name, null, this.configuration);
         },
         remove: function(productHandle) {
             var recentlyViewed = this.read();
             var position = jQuery.inArray(productHandle, recentlyViewed);
             if (position !== -1) {
                 recentlyViewed.splice(position, 1);
                 this.write(recentlyViewed);
             }
         }
     };
 
     var finalize = function() {
         var items = wrapper.find('.item')
         if (items.length <= 2) $('#recently-viewed-products-list').addClass('center');
 
         $('#recently-viewed-products-list-2').addClass('recently-viewed-loaded');
         convertActiveCurrency();
         
         wrapper.show();
         // If we have a callback.
         if (config.onComplete) {
             try {
                 config.onComplete();
             } catch (error) {}
         }
     };
 
     var moveAlong = function() {
         if (productHandleQueue.length && shown < config.howManyToShow) {
             var url = window.routes.root + '/products/' + productHandleQueue[0] + '?view=ajax_recently_viewed';
 
             jQuery.ajax({
                 type: 'get',
                 url: url,
                 cache: false,
                 success: function(product) {
                     wrapper.append(product);
                     productHandleQueue.shift();
                     shown++;
                     moveAlong();
                 },
                 error: function() {
                     cookie.remove(productHandleQueue[0]);
                     productHandleQueue.shift();
                     moveAlong();
                 }
             });
         } else {
             finalize();
         }
     };
 
     var initRecentlyViewedSlider = function() {
         if(config.layout == 'slider'){
             var wrapper = $('.halo-recently-viewed-block'),
                 productGrid = wrapper.find('.products-carousel'),
                 itemToShow = productGrid.data('item-to-show'),
                 itemDots = productGrid.data('item-dots'),
                 itemDotsMb = productGrid.data('item-dots-mb'),
                 itemArrows = productGrid.data('item-arrows'),
                 itemArrowsMb = productGrid.data('item-arrows-mb'),
                 productCount = productGrid.find('.recently-viewed-product-card').length;

             var getVisibleSlides = function(requested) {
                 var requestedCount = parseInt(requested, 10);

                 if (!requestedCount || requestedCount < 1) {
                     requestedCount = 1;
                 }

                 if (productCount > 0) {
                     requestedCount = Math.min(requestedCount, productCount);
                 }

                 return requestedCount;
             };

             if(productGrid.length > 0 && !productGrid.hasClass('slick-initialized')) {
                 productGrid.slick({
                     mobileFirst: true,
                     adaptiveHeight: true,
                     vertical: false,
                     infinite: true,
                     slidesToShow: getVisibleSlides(1),
                     slidesToScroll: getVisibleSlides(1),
                     arrows: itemArrowsMb,
                     dots: itemDotsMb,
                     nextArrow: window.arrows.icon_next,
                     prevArrow: window.arrows.icon_prev,
                     rtl: window.rtl_slick,
                     responsive: 
                     [
                         {
                             breakpoint: 1599,
                             settings: {
                                 arrows: itemArrows,
                                 dots: itemDots,
                                 get slidesToShow() {
                                     if(itemToShow !== undefined && itemToShow !== null && itemToShow !== ''){
                                         return this.slidesToShow = getVisibleSlides(itemToShow);
                                     } else {
                                         return this.slidesToShow = getVisibleSlides(1);
                                     }
                                 },
                                 get slidesToScroll() {
                                     if(itemToShow !== undefined && itemToShow !== null && itemToShow !== ''){
                                         return this.slidesToScroll = getVisibleSlides(itemToShow);
                                     } else {
                                         return this.slidesToScroll = getVisibleSlides(1);
                                     }
                                 }
                             }
                         },
                         {
                             breakpoint: 1024,
                             settings: {
                                 arrows: itemArrows,
                                 dots: itemDots,
                                 get slidesToShow() {
                                     if(itemToShow !== undefined && itemToShow !== null && itemToShow !== ''){
                                         if(itemToShow == 5){
                                             return this.slidesToShow = getVisibleSlides(itemToShow - 1);
                                         } else {
                                             return this.slidesToShow = getVisibleSlides(itemToShow);
                                         }
                                     } else {
                                         return this.slidesToShow = getVisibleSlides(1);
                                     }
                                 },
                                 get slidesToScroll() {
                                     if(itemToShow !== undefined && itemToShow !== null && itemToShow !== ''){
                                         if(itemToShow == 5){
                                             return this.slidesToScroll = getVisibleSlides(itemToShow - 1);
                                         } else {
                                             return this.slidesToScroll = getVisibleSlides(itemToShow);
                                         }
                                     } else {
                                         return this.slidesToScroll = getVisibleSlides(1);
                                     }
                                 }
                             }
                         },
                         {
                             breakpoint: 991,
                             settings: {
                                 arrows: itemArrowsMb,
                                 dots: itemDotsMb,
                                 slidesToShow: getVisibleSlides(4),
                                 slidesToScroll: getVisibleSlides(4)
                             }
                         },
                         {
                             breakpoint: 767,
                             settings: {
                                 arrows: itemArrowsMb,
                                 dots: itemDotsMb,
                                 slidesToShow: getVisibleSlides(3),
                                 slidesToScroll: getVisibleSlides(3)
                             }
                         },
                         {
                             breakpoint: 320,
                             settings: {
                                 arrows: itemArrowsMb,
                                 dots: itemDotsMb,
                                 slidesToShow: getVisibleSlides(2),
                                 slidesToScroll: getVisibleSlides(2)
                             }
                         }
                     ]
                 });
             }
         }
     };

     var revealRecentlyViewedBlock = function() {
         var recentlyViewedRow = $('.halo-recently-viewed-block .recentlyViewed-row'),
             recentlyViewedBlock = recentlyViewedRow.closest('.halo-recently-viewed-block'),
             productCards = recentlyViewedRow.find('.recently-viewed-product-card');

         if (!productCards.length) {
             recentlyViewedBlock.remove();
             return;
         }

         recentlyViewedRow.attr('data-product-count', productCards.length);

         recentlyViewedBlock
             .removeClass('recently-viewed-loading')
             .addClass('recently-viewed-ready')
             .attr('aria-hidden', 'false');

         initRecentlyViewedSlider();
         convertActiveCurrency();

         if (config.onComplete) {
             try {
                 config.onComplete();
             } catch (error) {}
         }
     };

     var doAlong = function() {
         var recentlyViewedRow = $('.halo-recently-viewed-block .recentlyViewed-row');

         if (!recentlyViewedRow.length) return;

         if (productHandleQueue.length && shown < config.howManyToShow) {
             var productHandle = productHandleQueue.shift(),
                 url = window.routes.root + '/products/' + productHandle + '?view=ajax_recently_viewed_card';

             $.ajax({
                 type: 'get',
                 url: url,
                 cache: false,
                 success: function(data) {
                     var html = (data || '').trim(),
                         parsedHtml = $('<div>').html(html),
                         productCards = parsedHtml.find('.product').filter(function() {
                             return !$(this).parent().closest('.product').length;
                         });

                     if (productCards.length) {
                         if (config.swipe) {
                             productCards.addClass('slider__slide grid__item');
                         }

                         productCards.addClass('recently-viewed-product-card');
                         recentlyViewedRow.append(productCards);
                         shown++;
                     } else {
                         cookie.remove(productHandle);
                     }
                 },
                 error: function() {
                     cookie.remove(productHandle);
                 },
                 complete: function() {
                     doAlong();
                 }
             });
         } else {
             revealRecentlyViewedBlock();
         }
     };

     var convertActiveCurrency = function() {
         var activeCurrency = document.getElementById('currencies')?.querySelector('.active')?.getAttribute('data-currency');
         var shouldConvertCurrency = typeof Currency !== 'undefined' && activeCurrency && ((window.show_multiple_currencies && Currency.currentCurrency != window.shop_currency) || window.show_auto_currency);

         if (shouldConvertCurrency) {
             Currency.convertAll(window.shop_currency, activeCurrency, 'span.money', 'money_format');
         }
     };
 
     return {
         resizeImage: function(src, size) {
             if (size == null) {
                 return src;
             }
 
             if (size == 'master') {
                 return src.replace(/http(s)?:/, "");
             }
 
             var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i);
 
             if (match != null) {
                 var prefix = src.split(match[0]);
                 var suffix = match[0];
 
                 return (prefix[0] + "_" + size + suffix).replace(/http(s)?:/, "")
             } else {
                 return null;
             }
         },
 
         showRecentlyViewed: function(params) {
             var params = params || {};
 
             // Update defaults.
             jQuery.extend(config, params);
 
             // Read cookie.
             productHandleQueue = cookie.read();
 
             // Template and element where to insert.
             template = config.templateId;
             wrapper = jQuery('#' + config.wrapperId);
             shown = 0;

             if (wrapper.length) {
                 wrapper.empty();
                 wrapper
                     .closest('.halo-recently-viewed-block')
                     .addClass('recently-viewed-loading')
                     .removeClass('recently-viewed-ready')
                     .attr('aria-hidden', 'true');
             }

             // How many products to show.
             config.howManyToShow = Math.min(productHandleQueue.length, config.howManyToShow);
 
             // If we have any to show.
             if (config.howManyToShow && wrapper.length) {
                 // Getting each product with an Ajax call and rendering it on the page.
                 if (template == 'recently-viewed-product-popup'){
                     moveAlong();
                 } else {
                     doAlong();
                 }
             } else if (wrapper && wrapper.length) {
                 wrapper.closest('.halo-recently-viewed-block').remove();
             }
         },
 
         getConfig: function() {
             return config;
         },
 
         clearList: function() {
             cookie.destroy();
         },
 
         recordRecentlyViewed: function(params) {
             var params = params || {};
 
             // Update defaults.
             jQuery.extend(config, params);
 
             // Read cookie.
             var recentlyViewed = cookie.read();
 
             // If we are on a product page.
             if (window.location.pathname.indexOf('/products/') !== -1) {
                 // What is the product handle on this page.
                 var splitted = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/);
                 if (splitted == null) {
                     var productHandle = decodeURIComponent(window.location.pathname.split('/products/')[1]);
                 } else {
                   var productHandle = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/)[1];
                 }
                 // In what position is that product in memory.
                 var position = jQuery.inArray(productHandle, recentlyViewed);
                 // If not in memory.
                 if (position === -1) {
                     // Add product at the start of the list.
                     recentlyViewed.unshift(productHandle);
                     // Only keep what we need.
                     recentlyViewed = recentlyViewed.splice(0, config.howManyToStoreInMemory);
                 } else {
                     // Remove the product and place it at start of list.
                     recentlyViewed.splice(position, 1);
                     recentlyViewed.unshift(productHandle);
                 }
 
                 // Update cookie.
                 cookie.write(recentlyViewed);
             }
         }
     };
 })();
